import { Filters } from '../../_flux/constants/filter/filters';

export const CHECK_ORDER = [
    Filters.VEHICLE_MAKE,
    Filters.VEHICLE_MODEL,
    Filters.VEHICLE_YEAR,
    Filters.VEHICLE_SERIES_CHASSIS,
    Filters.VEHICLE_ENGINE,
    Filters.VEHICLE_DETAILS,
    Filters.VEHICLE_TYRES,
];
